import { MenuItem, Select } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import MultiSelectAutoComplete from "./MultiSelectAutoComplete";
import ApiClient from "utils/ApiClient";

const ShareSheetUpdater = ({ emailAndRoles, shareSheet, cancelProcess }) => {
  const [roles, setRoles] = useState([...emailAndRoles.roles]);
  const [role, setRole] = useState("Standard Users");
  const [selectedEmails, setSelectedEmails] = useState(
    emailAndRoles?.emails.map((el) => ({ email: el, full_name: "" }))
  );
  const [activeUsers, setActiveUsers] = useState([]);

  const loadEmails = async () => {
    try {
      let resp = await ApiClient.Account.getActiveUsers();
      if (resp.success) {
        setActiveUsers(resp.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadEmails();
  }, []);

  const handleChange = (e) => {
    setRole(e.target.value);
  };

  const showError = (message, type) => {
    window.appStore.notificationStore.showNotification(message, type ? "success" : "error");
  };

  const onSubmit = () => {
    if (selectedEmails.length == 0) {
      showError("Required Emails.", false);
      return;
    }
    let invalidEmails = "";
    selectedEmails.forEach((el) => {
      if (!validateEmail(el.email)) {
        invalidEmails += invalidEmails.length > 0 ? ", " + el.email : el.email;
      }
    });
    if (invalidEmails.length > 0) {
      showError("Invalid emails (" + invalidEmails + ")", false);
      return;
    }
    shareSheet({ emails: selectedEmails.map((el) => el.email).join(","), role: role });
  };

  const onEmailsChange = (e, newValue) => {
    let updateValues = newValue.map((el) => {
      if (typeof el === "string") {
        el = { email: el, full_name: "" };
      }
      return el;
    });
    setSelectedEmails(updateValues);
  };

  const onCancel = () => {
    cancelProcess();
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "20px",
      }}
    >
      <h6
        style={{
          fontWeight: "bold",
          marginBottom: "15px",
        }}
      >
        Unable to find given role. Please select one from the given dropdown.
      </h6>
      <div style={styles.container}>
        <strong>Role</strong>
        <Select style={styles.fields} variant="outlined" value={role} onChange={handleChange}>
          {roles.map((role) => {
            return <MenuItem value={role}>{role}</MenuItem>;
          })}
        </Select>
      </div>
      <div style={styles.container}>
        <div>
          <strong>Emails</strong>
        </div>
        <MultiSelectAutoComplete
          isError={selectedEmails.length == 0}
          selectedOptions={selectedEmails}
          onSelect={onEmailsChange}
          activeOptions={activeUsers}
        />
      </div>
      <div style={styles.shareButton}>
        <Button style={styles.button} onClick={onCancel} color="secondary">
          Cancel
        </Button>
        <Button
          style={{ ...styles.button }}
          onClick={onSubmit}
          disabled={selectedEmails.length == 0}
          variant="contained"
          color="primary"
        >
          Share
        </Button>
      </div>
    </div>
  );
};

export default ShareSheetUpdater;

const styles = {
  fields: {
    padding: "10px 0px",
  },
  shareButton: {
    display: "flex",
    justifyContent: "flex-end",
    paddingTop: "10px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "10px",
  },
  button: {
    margin: "2px",
  },
};
